import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // 🛑 Import useNavigate
import { getTemplates, createTemplate, deleteTemplate } from '../../services/templateAPI';
import { Button, Input, Form, Modal, Spin } from 'antd';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { setLoading, setTemplates, setError, addTemplate, removeTemplate } from '../../redux/slices/templateSlice'; // Import the actions

const TemplateManagementPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // 🛑 Initialize navigate
  const { templates, loading, error } = useSelector(state => state.template);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [templateData, setTemplateData] = useState({ title: '', category: '', sections: [] });
  

  const fetchTemplates = async () => {
    dispatch(setLoading(true)); // set loading state
    try {
      const response = await getTemplates();
      const templatesArray = response || [];
      dispatch(setTemplates(templatesArray)); 
      dispatch(setLoading(false));// set templates in state
    } catch (error) {
      dispatch(setError(error.message)); // set error in state
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleCreateTemplate = async () => {
    try {
      const created = await createTemplate(templateData);
      dispatch(addTemplate(created)); // add the new template
      setIsModalVisible(false);
      fetchTemplates(); // Refresh the template list after creation
      setTemplateData({ title: '', category: '', sections: [] });
    } catch (error) {
      dispatch(setError(error.message)); // handle error
    }
  };

  const handleDeleteTemplate = async (templateId) => {
    try {
      await deleteTemplate(templateId);
      dispatch(removeTemplate(templateId)); // remove the template by ID
    } catch (error) {
      dispatch(setError(error.message)); // handle error
    }
  };

  const handleManageChecklist = (templateId) => {
    navigate(`/admin/checklist/${templateId}`); // 🛑 Navigate to checklist page
  };

  const handleChange = (e) => {
    setTemplateData({
      ...templateData,
      [e.target.name]: e.target.value,
    });
  };

  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="p-2">
      <div className="max-w-5xl mx-auto bg-white  p-8">
        <div className="flex flex-row flex-end r-0">
                      
                    <Button  onClick={() => navigate(-1)}>Back </Button>
                    <div></div>
                    </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Audit Management</h2>

        {loading && <div className="flex justify-center py-4"><Spin size="large" /></div>}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="mb-6">
          <Button
            type="primary"
            onClick={handleModalOpen}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            <PlusIcon className="w-4 h-4 mr-2 inline-block" />
            Create Audit Template
          </Button>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Existing Audit Templates</h3>
          {templates && templates.length > 0 ? (
            <ul className="space-y-3">
              {templates.map(template => (
                template && template.title ? (
                  <li key={template._id} className="bg-white hover:bg-gray-50  rounded-md border shadow-sm p-4 flex flex-col md:flex-row md:items-center justify-between space-y-3 md:space-y-0">
                    <span className="text-gray-800">{template.title} - {template.category}</span>
                    <div className="flex gap-2">
                      <Button
                        type="default"
                        onClick={() => handleManageChecklist(template._id)}
                        className="bg-gradient-to-r from-blue-500 to-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Manage Checklist
                      </Button>
                      <Button
                        type="primary"
                        danger
                        loading={loading}
                        icon={<TrashIcon className="w-4 h-4" />}
                        onClick={() => handleDeleteTemplate(template._id)}
                        className="focus:outline-none bg-gradient-to-r from-red-500 to-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                    
                      </Button>
                    </div>
                  </li>
                ) : null
              ))}
            </ul>
          ) : (
            <p className="text-gray-600">No templates found.</p>
          )}
        </div>

        <Modal
          title="Create New Template"
          visible={isModalVisible}
          onOk={handleCreateTemplate}
          onCancel={handleModalClose}
          footer={[
            <Button key="cancel" onClick={handleModalClose}>
              Cancel
            </Button>,
            <Button
              key="create"
              type="primary"
              loading={loading}
              onClick={handleCreateTemplate}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Create
            </Button>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item label="Title">
              <Input
                name="title"
                value={templateData.title}
                onChange={handleChange}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </Form.Item>
            <Form.Item label="Category">
              <Input
                name="category"
                value={templateData.category}
                onChange={handleChange}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default TemplateManagementPage;
